<template>
  <BaseDialog
    :ref="name"
    width="md"
    height="auto"
    mobile-height="full"
    :name="name"
    class="select-tutor-dialog"
  >
    <template #body>
      <div v-if="getTutorSelect.teacher" class="mt-4 text-center">
        <BaseAvatarTeacher :img="getTutorSelect.teacher.picture" mode="small" />
        <p class="text__body-1-xs--semibold mt-4">
          {{ getTutorSelect.teacher.fullname }}
        </p>
        <p class="text__body-2-md--semibold mt-3">
          {{ getTutorSelect.course_name }}
        </p>
        <BaseIcon
          :name="errorModal ? 'error' : 'note_add'"
          :color="errorModal ? 'error' :'success'"
          size="xl"
          class="mt-8"
        />
        <p class="text__body-1-md--semibold mt-2">
          <span v-if="!errorModal && !completedRequest">
            {{ $t('messages.tutor_select_added_completed_request',
                  {course: getTutorSelect.course_name, name: getTutorSelect.teacher.fullname}) }}
          </span>
          <span v-else>
            {{ errorModal? $t('messages.tutor_select_added_error') : $t('messages.tutor_select_added') }}
          </span>
        </p>
        <div class="select-tutor-dialog__actions">
          <BaseButton
            :label="errorModal ? $t('actions.current_request') : $t('common.actions.close')"
            outline
            size="sm-lg"
            class="w-5/12"
            @click="close"
          />
          <BaseButton
            shadow
            :label="errorModal ? $t('actions.view_tutor_list') : completedRequest ? $t('actions.view_request_status') : $t('actions.continue_request')"
            class="w-7/12"
            size="sm-lg"
            @click="submit"
          />
        </div>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseAvatarTeacher from '@design-system/base/avatar/avatar-teacher.old'

export default {
  name: 'TeacherListItemSelectTutorDialog',
  components: {
    BaseAvatarTeacher
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapGetters('teacher', ['getTutorSelect']),
    ...mapGetters('submitRequest', ['getRequestStepsName']),
    completedRequest () {
      return this.getTutorSelect?.is_completed_teacher_request
    },
    errorModal () {
      return this.getTutorSelect?.action === 'ERROR_MODAL'
    }
  },
  beforeDestroy () {
    this.$refs[this.name].hide()
  },
  methods: {
    close () {
      if (this.errorModal) {
        this.$router.push(
          this.localePath({
            name: this.getRequestStepsName.TRACKING,
            params: { id: this.getTutorSelect?.teacher_request_id }
          })
        )
      } else {
        this.$refs[this.name].hide()
      }
    },
    submit () {
      if (this.errorModal) {
        this.$router.replace(
          this.$links.tutor_list_params(this.$nuxt, { link: this.getTutorSelect?.tutor_list_link })
        )
      } else {
        this.$router.push(
          this.localePath({
            name: this.getRequestStepsName[this.getTutorSelect?.submitting_step],
            params: { id: this.getTutorSelect?.teacher_request_id }
          })
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.select-tutor-dialog {
  &__actions {
    @apply fixed flex space-x-4 bottom-0 bg-white w-full z-40 p-4 inset-x-0 pb-6 shadow-banner;
    @screen lg {
      @apply relative mt-16 flex items-center space-x-2 shadow-none p-0 z-0;
    }
  }
}
</style>
